import { render } from "./BridgeClock3.vue?vue&type=template&id=9fe8a8bc&scoped=true"
import script from "./BridgeClock3.vue?vue&type=script&lang=js"
export * from "./BridgeClock3.vue?vue&type=script&lang=js"

import "./BridgeClock3.vue?vue&type=style&index=0&id=9fe8a8bc&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fe8a8bc"]])

export default __exports__